import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeBox() {
  return <div className="bg-gradient-to-r from-pink-50 to-purple-50 border-2 border-pink-300 rounded-lg p-8 space-y-4" data-id="element-182">
      <div className="flex items-center justify-center gap-3" data-id="element-183">
        <Shield className="w-12 h-12 text-pink-600" data-id="element-184" />
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-185">
          Covered By A 100% Money Back Guarantee!
        </h3>
      </div>
      <div className="w-32 h-32 bg-pink-500 rounded-full flex items-center justify-center mx-auto" data-id="element-186">
        <div className="text-center text-white" data-id="element-187">
          <div className="text-3xl font-bold" data-id="element-188">100%</div>
          <div className="text-sm font-semibold" data-id="element-189">Money Back</div>
          <div className="text-sm font-semibold" data-id="element-190">Guarantee</div>
        </div>
      </div>
      <div className="text-center space-y-3" data-id="element-191">
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-192">
          You can try this micro-infusion device completely risk-free!
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-193">
          That means if you are not 100% satisfied with your purchase, the
          manufacturer will return your investment... every single penny... with
          zero hard feelings.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-194">
          NO hassles. NO annoying hoops to jump through. NO questions asked.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-195">
          They know the likelihood of that happening is low... and that's
          because they've spent years perfecting their formula.
        </p>
      </div>
    </div>;
}